module.exports = __webpack_public_path__ + "img/je.0641dc3c.svg";